import { useEffect, useRef, useState } from "react";
import { useReducedMotion } from "framer-motion";

const RADIUS = 400;

const CursorSpotlight = () => {
  const ref = useRef<HTMLDivElement>(null);
  const prefersReducedMotion = useReducedMotion();
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (prefersReducedMotion) return;
    if (typeof window === "undefined") return;
    if (!window.matchMedia("(hover: hover)").matches) return;
    setEnabled(true);
  }, [prefersReducedMotion]);

  useEffect(() => {
    if (!enabled) return;
    const el = ref.current;
    if (!el) return;

    let targetX = window.innerWidth / 2;
    let targetY = window.innerHeight / 2;
    let currentX = targetX;
    let currentY = targetY;
    let raf = 0;

    const onMove = (e: MouseEvent) => {
      targetX = e.clientX;
      targetY = e.clientY;
    };

    const tick = () => {
      currentX += (targetX - currentX) * 0.12;
      currentY += (targetY - currentY) * 0.12;
      el.style.transform = `translate3d(${(currentX - RADIUS / 2).toFixed(2)}px, ${(currentY - RADIUS / 2).toFixed(2)}px, 0)`;
      raf = requestAnimationFrame(tick);
    };

    window.addEventListener("mousemove", onMove, { passive: true });
    raf = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
    };
  }, [enabled]);

  if (!enabled) return null;

  return (
    <div
      ref={ref}
      aria-hidden="true"
      className="fixed top-0 left-0 pointer-events-none"
      style={{
        width: RADIUS,
        height: RADIUS,
        background: "radial-gradient(circle, hsl(152 35% 55% / 0.08) 0%, transparent 60%)",
        mixBlendMode: "screen",
        zIndex: 1,
        willChange: "transform",
      }}
    />
  );
};

export default CursorSpotlight;
